import { useContext } from "react";
import { ModalContext } from "./ModalProvider";

export default function useModal({
  component,
  headerIcon,
  hideHeader,
  showDivider,
  modalHeader,
  showCloseIcon,
  onCloseIconClick,
  componentProps,
  modalSubHeader,
  pathIllustration
}) {
  const { open } = useContext(ModalContext);
  return {
    open: componentPropsOnMount =>
      open({
        component,
        headerIcon,
        hideHeader,
        showDivider,
        modalHeader,
        showCloseIcon,
        onCloseIconClick,
        modalSubHeader,
        pathIllustration,
        componentProps:
          componentPropsOnMount !== undefined
            ? componentPropsOnMount
            : componentProps
      })
  };
}
